import OrderDetail from '../order-history/order/detail';
import React from 'react';
import { useDateFormat, useFormat } from 'helpers/hooks/useFormat';
import ChevronLeftIcon from 'components/icons/chevron-left';
import { AccountDetailsProps } from 'components/commercetools-ui/account/details';
import { Order } from '@Types/cart';
import ServiceArea from '../utils/service';

export type OrderDetailProps = {
  order?: Order;
  onCloseContent?: () => void;
};

const OrderDetailSection: React.FC<AccountDetailsProps & OrderDetailProps> = ({
  enableBtn,
  buttonText,
  buttonLink,
  linkList,
  order,
  onCloseContent,
}) => {
  const { formatDate } = useDateFormat();
  const { formatMessage: formatAccountMessage } = useFormat({ name: 'account' });

  const onBackClick = () => {
    window.location.hash = '#orders';
  };

  return !order ? (
    <p>Order not found</p>
  ) : (
    <div className="flex flex-col gap-8">
      <div className="hidden lg:flex">
        <button onClick={onBackClick} className="flex gap-2 text-secondary-600 transition-colors hover:opacity-90">
          <ChevronLeftIcon className="size-6 fill-secondary-600" />
          <span className="border-b border-secondary-600">Zurück zu meinen Bestellungen</span>
        </button>
      </div>
      <h3 className="flex items-center gap-2 font-headline text-xl">
        <button onClick={onCloseContent} className="lg:hidden">
          <ChevronLeftIcon className="size-6" />
        </button>
        {formatAccountMessage({
          id: 'order.from',
          defaultMessage: 'order from {orderDate}',
          values: { orderDate: formatDate(order.createdAt) },
        })}
      </h3>

      <OrderDetail order={order} />

      <ServiceArea enableBtn={enableBtn} buttonText={buttonText} buttonLink={buttonLink} linkList={linkList} />
    </div>
  );
};

export default OrderDetailSection;
